import React from "react";
import { Descriptions, Space, Image } from "antd";
import dayjs from "dayjs";
import { AttendanceRecordCreateData, EmployeeDetail } from "@app/api/admin";

interface EmployeeBasicInfoProps {
  viewEmployeeData?: AttendanceRecordCreateData;
  viewEmployeeInfo?: EmployeeDetail;
}

const EmployeeBasicInfo: React.FC<EmployeeBasicInfoProps> = ({
  viewEmployeeData,
  viewEmployeeInfo,
}) => {
  if (!viewEmployeeData) {
    return null;
  }
  return (
    <Descriptions bordered column={2} size="small">
      {/* 基本员工信息 */}

      <Descriptions.Item label="员工姓名">
        {viewEmployeeData.employee_name || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="手机号码">
        {viewEmployeeData.phone_number || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="部门">
        {viewEmployeeData.department_name || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="员工编号">
        {viewEmployeeData.employee_number || "-"}
      </Descriptions.Item>

      <Descriptions.Item label="性别">
        {viewEmployeeInfo?.gender || "-"}
      </Descriptions.Item>
      <Descriptions.Item label="入职日期">
        {viewEmployeeInfo?.hire_date
          ? dayjs(viewEmployeeInfo.hire_date).format("YYYY-MM-DD")
          : "-"}
      </Descriptions.Item>
      {/* 学历 */}
      <Descriptions.Item label="学历">
        {viewEmployeeInfo?.education || "-"}
      </Descriptions.Item>
      {/* 政治面貌 */}
      <Descriptions.Item label="政治面貌">
        {viewEmployeeInfo?.political_status || "-"}
      </Descriptions.Item>
      {/* 工龄 */}
      <Descriptions.Item label="工龄">
        {(viewEmployeeInfo?.seniority || 0) + "年"}
      </Descriptions.Item>
      <Descriptions.Item label="是否参与工龄计算">
        {viewEmployeeInfo?.participate_seniority_calculation ? "是" : "否"}
      </Descriptions.Item>

      {/*  birthday_type*/}
      <Descriptions.Item label="生日类型">
        {viewEmployeeInfo?.birthday_type || "-"}
      </Descriptions.Item>
      {/* 生日 */}
      <Descriptions.Item label="生日">
        {viewEmployeeInfo?.birthday
          ? dayjs(viewEmployeeInfo.birthday).format("YYYY-MM-DD")
          : "-"}
      </Descriptions.Item>
      {/* 状态*/}
      <Descriptions.Item label="状态">
        {viewEmployeeInfo?.status || "-"}
      </Descriptions.Item>
      {/* salary_payment_method */}
      <Descriptions.Item label="薪资支付方式">
        {viewEmployeeInfo?.salary_payment_method || "-"}
      </Descriptions.Item>
      {/* 身份证照片 */}
      <Descriptions.Item label="身份证照片">
        <Space>
          <Image
            src={viewEmployeeInfo?.id_card_front_url}
            alt="身份证正面"
            style={{ width: "100px", height: "auto" }}
          />
          <Image
            src={viewEmployeeInfo?.id_card_back_url}
            alt="身份证反面"
            style={{ width: "100px", height: "auto" }}
          />
        </Space>
      </Descriptions.Item>
      {/* 驾驶证照片 */}
      <Descriptions.Item label="驾驶证照片">
        <Space>
          <Image
            src={viewEmployeeInfo?.driver_license_front_url}
            alt="驾驶证正面"
            style={{ width: "100px", height: "auto" }}
          />
          <Image
            src={viewEmployeeInfo?.driver_license_back_url}
            alt="驾驶证反面"
            style={{ width: "100px", height: "auto" }}
          />
        </Space>
      </Descriptions.Item>
      {/* 紧急联系人 */}
      <Descriptions.Item label="紧急联系人">
        {viewEmployeeInfo?.emergency_contact || "-"}
      </Descriptions.Item>
      {/* 紧急联系人手机号 */}
      <Descriptions.Item label="紧急联系人手机号">
        {viewEmployeeInfo?.emergency_contact_phone || "-"}
      </Descriptions.Item>

      {/* 角色信息 */}
      {/* <Descriptions.Item label="角色" span={2}>
        {viewEmployeeData.roles
          ? Array.isArray(viewEmployeeData.roles) &&
            viewEmployeeData.roles.length > 0
            ? viewEmployeeData.roles.map((role: any) => role.name).join("、")
            : "暂无角色"
          : "暂无角色"}
      </Descriptions.Item> */}

      {/* 公司信息 */}
      {viewEmployeeData.companies && viewEmployeeData.companies.length > 0 && (
        <>
          <Descriptions.Item label="关联公司" span={2}>
            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
              {viewEmployeeData.companies.map(
                (companyInfo: any, index: number) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: "16px",
                      padding: "12px",
                      border: "1px solid #f0f0f0",
                      borderRadius: "6px",
                    }}
                  >
                    <Descriptions size="small" column={1} bordered>
                      <Descriptions.Item label="公司名称">
                        {companyInfo.company_name || "-"}
                      </Descriptions.Item>

                      <Descriptions.Item label="状态">
                        <span
                          style={{
                            color:
                              companyInfo.status === 1 ? "#52c41a" : "#ff4d4f",
                          }}
                        >
                          {companyInfo.status_text || "-"}
                        </span>
                      </Descriptions.Item>
                      <Descriptions.Item label="加入时间">
                        {companyInfo.joined_at
                          ? dayjs(companyInfo.joined_at).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          : "-"}
                      </Descriptions.Item>
                      {companyInfo.left_at && (
                        <Descriptions.Item label="离开时间">
                          {dayjs(companyInfo.left_at).format(
                            "YYYY-MM-DD HH:mm:ss"
                          )}
                        </Descriptions.Item>
                      )}

                      {/* 公司详细信息 */}
                      {companyInfo.company && (
                        <>
                          <Descriptions.Item label="法定代表人">
                            {companyInfo.company.legal_representative || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="注册号">
                            {companyInfo.company.registration_number || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="统一社会信用代码">
                            {companyInfo.company.unified_social_code || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="公司类型">
                            {companyInfo.company.company_type || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="注册日期">
                            {companyInfo.company.registration_date
                              ? dayjs(
                                  companyInfo.company.registration_date
                                ).format("YYYY-MM-DD")
                              : "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="注册资本">
                            {companyInfo.company.registered_capital || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="经营范围">
                            {companyInfo.company.business_scope || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="注册地址">
                            {companyInfo.company.registered_address || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="经营地址">
                            {companyInfo.company.operating_address || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="联系电话">
                            {companyInfo.company.contact_phone || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="联系邮箱">
                            {companyInfo.company.contact_email || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="网站">
                            {companyInfo.company.website || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="备注">
                            {companyInfo.company.remark || "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="创建时间">
                            {companyInfo.company.created_at
                              ? dayjs(companyInfo.company.created_at).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              : "-"}
                          </Descriptions.Item>
                          <Descriptions.Item label="更新时间">
                            {companyInfo.company.updated_at
                              ? dayjs(companyInfo.company.updated_at).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              : "-"}
                          </Descriptions.Item>
                        </>
                      )}
                    </Descriptions>
                  </div>
                )
              )}
            </div>
          </Descriptions.Item>
        </>
      )}
    </Descriptions>
  );
};

export default EmployeeBasicInfo;
